/* ============================================================================
   STICKY CART + PROMO RIBBON  —  pure JS

   Split out of the inline <script>. LOGIC IS UNCHANGED — the only difference is
   that the twelve Liquid `settings.*` values now come from
   window.__promoRibbonConfig, which the Liquid block emits inline BEFORE this
   file loads.

   Load order (guaranteed): the inline config <script> runs during parsing, this
   file is `defer` so it runs after parsing. Config is always present by the time
   anything here executes.

   NOTE: updatePromoRibbon() is intentionally left as a TOP-LEVEL function
   declaration (no IIFE wrapper) so it stays on `window`, exactly as it was when
   inline. Every call site in the original is commented out, but anything else on
   the page that calls it globally keeps working.
   ============================================================================ */

document.addEventListener("DOMContentLoaded", () => {
  const stickyCart = document.getElementById("view-cart-inner");
  const cartQuantityElem = document.getElementById("cart-quantity");
  const cartTotalElem = document.getElementById("cart-total");

 function updateCartView() {
    fetch('/cart.js') // Shopify cart endpoint
      .then((response) => response.json())
      .then((data) => {
        const { item_count, total_price, items, original_total_price } = data;

        if (item_count > 0 && total_price >0) {
          cartQuantityElem.textContent = item_count;
          cartTotalElem.textContent = `$ ${(total_price / 100).toFixed(2)}`;
         if (document.documentElement.scrollTop > 0){
                 stickyCart.classList.remove("hidden");
         }else{
            stickyCart.classList.remove("hidden");
         }
          // updatePromoRibbon(data);
        } else {
          stickyCart.classList.add("hidden");
         // updatePromoRibbon(data);
        }
      })
      .catch((error) => {
        //console.error("Error fetching cart:", error);
      });
  }

  // Update cart view initially
  updateCartView();

  // Poll Shopify's cart every 5 seconds for updates
  setInterval(updateCartView, 1000);


});
//
document.addEventListener('DOMContentLoaded', function() {
    const miniCart = document.getElementById("t4s-mini_cart");
    const viewCartButton = document.getElementById("view-cart-button");

    // Open mini cart
    if (viewCartButton) {
        viewCartButton.addEventListener('click', function() {
            if (miniCart) {
                miniCart.setAttribute("aria-hidden", "false");
            } else {
               // console.log('#t4s-mini_cart not found');
            }
        });
    } else {
        console.log('#view-cart-button not found');
    }

    // Close mini cart using event delegation
    document.body.addEventListener('click', function(event) {
        const closeCartButton = event.target.closest('#t4s-mini_cart .t4s-drawer__close');
        if (closeCartButton && miniCart) {
            miniCart.setAttribute("aria-hidden", "true");
        }
    });
});

//scroll code
 const stickyElement = document.getElementById('stickyViewCart-outer');
  let isScrolling;
  window.addEventListener('scroll', function() {
    stickyElement.classList.add('scrolled');  // Add the class while scrolling
    window.clearTimeout(isScrolling); // Set a timeout to run after scrolling ends
    isScrolling = setTimeout(function() {
      stickyElement.classList.remove('scrolled');  // Remove the class when scrolling stops
    }, 100); // 5 seconds
  }, false);

//cartupdate
// show promoribben
function updatePromoRibbon(data) {
  const promoRibbonElem = document.getElementById('promoRibbon'); // Assuming promo ribbon has this ID
   const cartComapreTotalElem = document.getElementById("cart-comparetotal");
  if (!promoRibbonElem) {
    console.error("Promo ribbon element not found!");
    return;
  }

// ── The ONLY change: these twelve values were inline Liquid, now they come from
//    the config object the Liquid block emits. Same values, same order.
  const PRCFG = window.__promoRibbonConfig || {};

// Define the quantity thresholds
  const countQty1 = PRCFG.minQty1;
  const countQty2 = PRCFG.minQty2;
// coupon code name
   const couponCode1 = PRCFG.couponCode1;
  const  couponCode2 = PRCFG.couponCode2;
// coupon code off percent
   const couponPer1 = PRCFG.couponPer1;
  const  couponPer2 = PRCFG.couponPer2;
  //add step 1 msg
 const  st1prefix = PRCFG.st1prefix;
  const  st1mdl = PRCFG.st1mdl;
   //add step 2 msg
 const  st2prefix = PRCFG.st2prefix;
  const  st2mdl = PRCFG.st2mdl;
   //add step 3 msg
 const  st3prefix = PRCFG.st3prefix;
  const  st3mdl = PRCFG.st3mdl;

//
  const { item_count, total_price, items, original_total_price } = data;// Get the current item count from the cart
//
let singSkuCount = 0;
let totalComparePrice = 0;
let promoMessage = "";
  items.forEach(item => {
   const itemElement = document.querySelector(`[data-pid="${item.product_id}"]`);
   const comparePriceElement = itemElement.querySelector('[data-compare-price]');
    //item is bundle or not
    if (itemElement && itemElement.classList.contains('pr-isbundle')) {
     // console.log('bundle Quantity:', item.quantity);
    }else{
     //  console.log('single sku:', item.quantity);
       singSkuCount += item.quantity;
    }
    //tottal compare price code
       if (comparePriceElement) {
       const comparePrice = parseFloat(comparePriceElement.getAttribute('data-compare-price').replace(/[^0-9.-]+/g, ""));  // Remove currency symbol
       totalComparePrice += comparePrice * item.quantity ;  // Add to total (considering quantity)
     }
  });
//console.log('Total single sku count:', singSkuCount);
// console.log('Total compare price:', totalComparePrice.toFixed(2));
 // console.log('Total original_price price:', original_total_price.toFixed(2));
  if (totalComparePrice > 0 && totalComparePrice > total_price) {
   cartComapreTotalElem.textContent = `$ ${(totalComparePrice / 100).toFixed(0)}`;
  }else if (original_total_price > total_price){
   cartComapreTotalElem.textContent = `$ ${(original_total_price / 100).toFixed(0)}`;
  }
// If countQty1 is 0, show the message related to countQty2
if (countQty1 === 0) {
  if (countQty2 > 0) {
    if (singSkuCount === 0) {
      promoMessage = `<div>${st1prefix}  <b>${countQty2} </b> ${st1mdl}  <b> ${couponPer2} </b></div>`;
    } else if (singSkuCount < countQty2) {
      promoMessage = `<div>${st2prefix}  <b> ${countQty2 - singSkuCount} </b> ${st2mdl}  <b>${couponPer2}</b></div>`;
    } else  if (singSkuCount >= countQty2){
      promoMessage = `<div>${st3prefix}  <b> ${couponCode2}</b>${st3mdl}  <b> ${couponPer2}</b></div>`;
    } else  {
      promoMessage = `<div>${st1prefix}  <b> ${countQty2}</b> ${st1mdl} <b>  ${couponPer2}</b></div>`;
    }
  }
}
// If countQty2 is 0, show the message related to countQty1
else if (countQty2 === 0) {
  if (countQty1 > 0) {
    if (singSkuCount === 0) {
      promoMessage = `<div>${st1prefix}  <b> ${countQty1}</b>${st1mdl}  <b> ${couponPer1}</b></div>`;
    } else if (singSkuCount < countQty1) {
      promoMessage = `<div>${st2prefix}  <b> ${countQty1 - singSkuCount} </b>${st2mdl}  <b>${couponPer1}</b></div>`;
    } else if (singSkuCount >= countQty1) {
      promoMessage = `<div>${st3prefix} <b> ${couponCode1}</b>${st3mdl}  <b> ${couponPer1}</b></div>`;
    } else  {
      promoMessage = `<div>${st1prefix} <b> ${countQty1}</b>${st1mdl} <b>${couponPer1}</b></div>`;
    }
  }
}
// Handle the normal conditions for both thresholds being non-zero
else {
 if (singSkuCount === 0) {
    promoMessage = `<div>${st1prefix}  <b> ${countQty1}</b> ${st1mdl}<b> ${couponPer1}</b></div>`;
  } else if (singSkuCount > 0 && singSkuCount < countQty1) {
    promoMessage = `<div>${st2prefix}  <b> ${countQty1 - singSkuCount} </b>${st2mdl}  <b>${couponPer1}</b></div>`;
 } else if (singSkuCount >= countQty1 && singSkuCount < countQty2) {
    promoMessage = `<div>${st3prefix} <b> ${couponCode1} </b>${st3mdl} <b> ${couponPer1}</b> or ${st2prefix}  <b>${countQty2 - singSkuCount}</b> ${st2mdl} <b>${couponPer2}</b></div>`;
  } else if (singSkuCount >= countQty2) {
    promoMessage = `<div>${st3prefix}<b>${couponCode2}</b> ${st3mdl} <b> ${couponPer2}</b></div>`;
  } else  {
      promoMessage = `<div>${st1prefix} <b> ${countQty1}</b> ${st1mdl} <b>${couponPer1}</b></div>`;
    }
}

  // Update the promo ribbon with the message
 promoRibbonElem.innerHTML = promoMessage;
//console.log("promoMessage",promoMessage);

}
